import { render, staticRenderFns } from "./SellMultipleProductsPlus.vue?vue&type=template&id=1cff654e&scoped=true"
import script from "./SellMultipleProductsPlus.vue?vue&type=script&lang=js"
export * from "./SellMultipleProductsPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cff654e",
  null
  
)

export default component.exports